module.exports = __webpack_public_path__ + "img/atzaga_no.6180b1a1.png";